import { X } from "lucide-react";
import { cn } from "@/lib/utils";

interface NewItemsNotificationProps {
  count: number;
  onDismiss: () => void;
  className?: string;
}

export function NewItemsNotification({
  count,
  onDismiss,
  className,
}: NewItemsNotificationProps) {
  if (count === 0) return null;

  return (
    <div
      className={cn(
        "fixed top-20 left-1/2 -translate-x-1/2 z-50",
        "animate-in slide-in-from-top-2 duration-300",
        className
      )}
    >
      <div className="flex items-center gap-3 bg-primary text-primary-foreground px-4 py-2 rounded-full shadow-lg">
        <span className="font-medium text-sm">
          {count} new {count === 1 ? "order" : "orders"}
        </span>
        
        <button
          onClick={onDismiss}
          className="hover:bg-primary-foreground/20 rounded-full p-1 transition-colors"
          aria-label="Dismiss notification"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}

